"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformForV2Permission = void 0;
var _consts = require("./consts");
var transformForV2Permission = exports.transformForV2Permission = function transformForV2Permission() {
  var rowData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var result = {};
  Object.keys(rowData).forEach(function (dataKey) {
    var needTransformKey = _consts.V2_PERMISSION_API_KEY_MAP[dataKey];
    if (needTransformKey) {
      result[needTransformKey] = rowData[dataKey];
    } else {
      result[dataKey] = rowData[dataKey];
    }
  });
  return result;
};